import type { RequestBodyJSON } from 'openapi-typescript-helpers';
import { useCallback } from 'react';
import { coreApi } from '$api-clients/clients';
import type { CoreSchema } from '$api-clients/generated';
import { useCoreMutate } from '$api-clients/hooks';

export type UpdateReferralInput = RequestBodyJSON<
  CoreSchema.paths['/referrals/{referralId}']['patch']
>;

export function useUpdateReferral(referralId: string) {
  const mutate = useCoreMutate();

  const update = useCallback(
    async (input: UpdateReferralInput) => {
      const response = await coreApi.PATCH('/referrals/{referralId}', {
        params: { path: { referralId } },
        body: input,
      });

      if (response.error !== undefined) {
        throw new Error(
          typeof response.error === 'string'
            ? response.error
            : response.error.message,
        );
      }

      void Promise.all([
        mutate(['/referrals']),
        mutate(
          ['/referrals/{referralId}', { params: { path: { referralId } } }],
          response.data,
        ),
      ]);

      return { data: response.data };
    },
    [referralId, mutate],
  );

  return update;
}
